export enum PriceAdjustmentReservations {
	PRICE_ADJUSTMENT = 'true',
	NO_PRICE_ADJUSTMENT = 'false',
	ALL = '',
}
